import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import center from "../../asset/landing_images/landing-center.webp";
import up from "../../asset/landing-top.png";
import bottomleft from "../../asset/landing_images/landing-below1.webp";
import bottomright from "../../asset/landing_images/landing-below2.webp";

const LandingMessaging = () => {
  const { ref: componentRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const isSmallScreen = window.innerWidth < 768;

  const containerStyle = {
    position: "relative",
    width: "90%",
    maxWidth: "1200px",
    margin: "0 auto",
    backgroundImage: `url(${center})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    paddingTop: "100px",
    paddingBottom: "50px",
    textAlign: "center",
    color: "#fff",
    height: "700px",
    marginTop: "8rem",
    // border:'2px solid red'
  };

  const textOverlayStyle = {
    fontSize: "24px",
    fontWeight: "bold",
    lineHeight: "1.5",
    color: "#fff",
    marginBottom: "20px",
  };

  const subTextOverlayStyle = {
    fontSize: "16px",
    color: "#f4f4f4",
    marginTop: "10px",
  };

  const chatBubbleAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(-200px)",
    opacity: inView ? 1 : 0,
    config: { mass: 1, tension: 150, friction: 30 },
  });

  const voiceMessageAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(-200px)",
    opacity: inView ? 1 : 0,
    config: { mass: 1, tension: 150, friction: 30 },
  });

  const profileCardAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(200px)",
    opacity: inView ? 1 : 0,
    config: { mass: 1, tension: 150, friction: 30 },
  });

  return (
    <div ref={componentRef} style={containerStyle}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          paddingTop: "8rem",
        }}
      >
        <div style={textOverlayStyle}>
          <span style={{ color: "#11F3BF" }}>Private messaging </span> with your{" "}
          <span style={{ color: "#11F3BF" }}>Friends</span> and <br />
          <span style={{ color: "#42B5E7" }}>Followers, </span> sending videos,{" "}
          <span style={{ color: "#42B5E7" }}>Voice Messaging, </span>{" "}
          <span style={{ color: "#FFFD70" }}>Emojis,</span> Stickers
        </div>
        <div style={subTextOverlayStyle}>
          <i>Different opportunities to meet and connect with new people</i>
        </div>
      </div>

      {/* Chat Bubble Image with animation */}
      <animated.img
        src={up}
        alt="Chat Bubble"
        style={{
          position: "absolute",
          top: "-90px",
          left: "-20px",
          width: isSmallScreen ? "250px" : "443px",
          height: isSmallScreen ? "200px" : "331px",
          ...chatBubbleAnimation,
        }}
      />

      {/* Voice Message Image with animation */}
      <animated.img
        src={bottomleft}
        alt="Voice Message"
        style={{
          position: "absolute",
          bottom: "-30px",
          left: "40px",
          width: isSmallScreen ? "150px" : "260px",
          height: isSmallScreen ? "60px" : "80px",
          ...voiceMessageAnimation,
        }}
      />

      {/* Profile Card with animation */}
      <animated.div
        style={{
          position: "absolute",
          bottom: "50px",
          right: "-40px",
          display: "flex",
          alignItems: "center",
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "10px",
          color: "#333",
          fontSize: "12px",
          ...profileCardAnimation,
        }}
      >
        <img
          src={bottomright}
          alt="Profile"
          style={{
            width: isSmallScreen ? "60px" : "80px",
            height: isSmallScreen ? "45px" : "60px",
            borderRadius: "50%",
            marginRight: "8px",
          }}
        />
        <span>Jeffrey</span>
        <div
          style={{ marginLeft: "10px", color: "#00a3e0", fontWeight: "bold" }}
        >
          20k+ Followers
        </div>
      </animated.div>
    </div>
  );
};

export default LandingMessaging;
